<script setup lang="ts">
import ProgressSpinner from 'primevue/progressspinner'

import type { RProgressSpinnerProps } from './RProgressSpinner.types.ts'

defineProps<RProgressSpinnerProps>()
</script>
<template>
  <ProgressSpinner
    v-bind="$props"
    :unstyled="false"
  ></ProgressSpinner>
</template>
<style src="./RProgressSpinner.css"></style>
